import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Divider, FormCheckbox, ObjectSubscribersPanel } from "~/components/ModalObjects";
import { useProjectTemplateContext } from "../context";

export const TemplateDiscussionAndNotePanel = ({ element, onChange }) => {
  const { t } = useTranslation();
  const { template } = useProjectTemplateContext();

  const handleChangeHiddenFromClients = (value) => {
    onChange({ is_hidden_from_clients: value });
  };
  const handleChangePinnedStatus = (value) => {
    onChange({ is_pinned: value });
  };
  return (
    <>
      <FormCheckbox
        id="template_task_panel_hidden_for_clients"
        checked={element.is_hidden_from_clients}
        onChange={handleChangeHiddenFromClients}
        text={t("Hidden from clients")}
      />
      <FormCheckbox
        id="template_task_panel_pinned"
        checked={element.is_pinned}
        onChange={handleChangePinnedStatus}
        className="tw-mt-2"
        text={t("Pinned to top")}
      />
      <Divider className="tw-my-6" />
      <ObjectSubscribersPanel
        parentType={element.class}
        parentId={element.id}
        members={template?.get(`members`)?.toJS()}
        hiddenFromClients={element.is_hidden_from_clients}
        canEdit
      />
    </>
  );
};

TemplateDiscussionAndNotePanel.propTypes = {
  element: PropTypes.shape({
    id: PropTypes.number,
    class: PropTypes.string,
    is_hidden_from_clients: PropTypes.bool,
    is_pinned: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
